<template>
  <body class="mds" style="background: #F0F0F0;">
  <div class="mds-layout">
    <AppBar class="py-0 px-4" :username="username.user" :useremail="username.useremail" :userinit="username.userinitial" :pageName="pageName" :pageNameDescription="pageNameDescription" :fbpOwner="fbpOwner" :productCreatedBy="productCreatedBy" style="z-index:100;display: contents;" />
    <NavBar class="hero-image" :key="username.useremail" />
    <main id="main-content" class="mds-page mds-container" style="padding: 10px;">
      <router-view v-if="loggedInSuccess" :key="$route.fullPath"/>
      <mc-toast :open="showErrorToast" position="top-center" duration="5000" appearance="error" @close="closeErrorToastHandler">
        <mc-notification :body="defaultErrorMessage">
          <div>
            <small v-if="errorMessage"><strong>Error:</strong> {{ errorStatus }}. {{ errorError }}</small><br>
            <small v-if="errorMessage"><strong>Message:</strong> {{ errorMessage }}</small><br>
            <small v-if="requestId"><strong>Request ID:</strong> {{ requestId }}</small><br>
          </div>
        </mc-notification>
      </mc-toast>
      <span id="footer" className="footer-message">&copy; Powered By FDE</span>
    </main>
  </div>
  </body>
</template>

<script>
import NavBar from "@/components/templates/NavBar.vue";
import AppBar from '@/components/templates/AppBar.vue'
//Please remember to replace <YOUR_BRAND> in the below link, with your desire brand name, which can be one of these: maeu, hamburgsud, safm.
import "@maersk-global/fonts/maeu/fonts.css";
//Please remember to replace <YOUR_BRAND> in the below path, with your desire brand name, which can be one of these: maersk, hamburgsud, or sealand.
import "@maersk-global/mds-design-tokens/maersk/light/css/design-tokens-px.css";
//You can also import `@maersk-global/mds-foundations/css/foundations.css`, only if you need some global stylesheet i.e. CSS resets, classes that support our typography and table styles.
import '@maersk-global/mds-foundations/css/foundations.css';
import '@maersk-global/mds-foundations/css/_base-grid.css';
import '@maersk-global/mds-foundations/css/_typography.css';
import "@maersk-global/mds-components-core/mc-button";
import "@maersk-global/mds-components-core/mc-icon";
import '@maersk-global/mds-components-core-toast';
import '@maersk-global/mds-components-core-notification';

import {mapGetters, mapState} from "vuex";
import * as msal from "@azure/msal-browser";
import {PublicClientApplication} from "@azure/msal-browser";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import {AV_REQUEST_SCOPES, LOGIN_REQUEST_SCOPES} from "@/config/constants";
import {avActions, avLnsActions} from "@/actions";
import {store} from "./store/store.js";
import {getMsalIdToken} from "@/utils/helpers";
import { emitter } from "@/utils/axiosForMsal";

export default {
  name: 'App',
  components: {
    AppBar,
    NavBar
  },
  store,
  data() {
    return {
      showErrorToast: false,
      errorError: "",
      defaultErrorMessage : undefined,
      errorStatus: undefined,
      errorMessage: undefined,
      requestId: undefined,
      unauthorized: undefined,
      accessUserList: [
        'rakesh.v@maersk.com',
        'sayli.dalvi@maersk.com',
        'asifiqbal.sirmulla@maersk.com',
        'shrutinamra.mahapatra@maersk.com',
        'susmita.mohapatra@maersk.com',
        'mohammad.afreen.aqthar@maersk.com',
        'aravind.prathap@maersk.com',
        'subritha.m@maersk.com',
        'trinidad.pagliero@maersk.com',
        'duwi.siska.mawarsari@maersk.com',
        'igor.sapina@maersk.com',
        'aaron.bobo@maersk.com',
        'karin.bontenbal@maersk.com',
        'gideon.kok@maersk.com',
        'anna.ledin@maersk.com',
        'rasmus.p.hansen@maersk.com',
        'kristoffer.kuch@maersk.com',
        'chukwuma.mokwe@maersk.com',
        'anton.schonbeck@maersk.com',
        'chidchon.vichainarong@maersk.com',
        'michelle.li.yu.xu@maersk.com',
        'jingxue.zhang@maersk.com',
        'chrystal.sanchez@maersk.com',
        'sheila.pereira@maersk.com',
        'richard.smernoff@maersk.com',
        'tristan.bollardiere@maersk.com',
        'victoria.klyablina@maersk.com',
        'soeren.thomassen@maersk.com',
        'stefanie.hundertmark@maersk.com',
        'nikolaj.levin@maersk.com',
        'benedetta.bardin@maersk.com',
        'fabio.loriggio@maersk.com',
        'hanna.froberg@maersk.com',
        'adrien.betesta@maersk.com',
        'josef.knight@maersk.com',
        'helen.lan.ren@maersk.com',
        'chidchon.vichainarong@maersk.com'
      ],
      screenType: null,
      lnsAccessType: null,
      ownerUpdate: '',
      currentYear: new Date().getFullYear(),
      hasError: false,
      retryRequest: true,
      loggedInSuccess: false,
      msalLibrary: {},
      account: {},
      username: {
        user: "",
        useremail: "",
        userinitial: ""
      },
      version: 'Latest',
      versionDataList: [],
      versionList: null,
      pageName: sessionStorage.getItem("pageName") || "",
      pageNameDescription: sessionStorage.getItem("pageNameDescription") || "",
      productCreatedBy: sessionStorage.getItem("productCreatedBy") || "",
      fbpOwner: sessionStorage.getItem("fbpOwner") || "",
    }
  },
  computed: {
    ...mapState(["accessToken"]),
    ...mapGetters({
      user: "user"
    }),
    user: {
      get() {
        const {account} = this.$store.getters.getTokenData;
        return {
          jobTitle: "",
          mail: account?.username || "",
          displayName: account?.name || ""
        };
      },
      set(userData) {
        return userData;
      }
    }
  },
  watch: {
    "$i18n.locale"() {
      this.$changeIsLoadingOptions({
        slot: `
      <div class="px-5 py-3 bg-gray-800 rounded">
        <h3 class="text-3xl text-white"><i class="fas fa-spinner fa-spin"></i> ${this.$t("message.loading")}</h3>
      </div>
    `
      });
    }
  },
  async created() {
    this.msalLibrary = new PublicClientApplication(this.$store.state.msalConfig);
    await this.msalLibrary
        .handleRedirectPromise()
        .then(this.handleResponse)
        .catch((error) => {
          console.log(error);
          this.hasError = true;
        });
    emitter.on("api-error", this.showError);
  },
  mounted() {
    const accounts = this.msalLibrary.getAllAccounts();
    this.account = accounts ? accounts[0] : null;
    console.log("ENV:", process.env);
    console.log("VUE_APP_ENV:", process.env.VUE_APP_ENV);
    console.log("This for main");
    window.addEventListener("pageNameChanged", this.updatePageName);
  },
  beforeUnmount() {
    window.removeEventListener("pageNameChanged", this.updatePageName);
  },
  methods: {
    updatePageName() {
      this.pageName = sessionStorage.getItem("pageName");
      this.pageNameDescription = sessionStorage.getItem("pageNameDescription");
      this.fbpOwner = sessionStorage.getItem("fbpOwner");
      this.productCreatedBy = sessionStorage.getItem("productCreatedBy");
    },
    closeErrorToastHandler(){
      this.showErrorToast = false;
    },
    showError(error) {
      // Don't show toast for 401
      if (error?.status === 401 || error?.code === 401){
        return
      }

      this.showErrorToast = false;
      this.errorError = error.error;
      this.defaultErrorMessage  = error.defaultMessage;
      this.errorStatus = error.status;
      this.errorMessage = error.message;
      this.requestId = error.requestId;
      this.showErrorToast = true;
    },
    async signIn() {
      return this.msalLibrary
          .loginRedirect(LOGIN_REQUEST_SCOPES)
          .then(this.handleResponse)
          .catch(function (error) {
            console.error(error);
          });
    },
    async signOut() {
      await this.msalLibrary
          .logout({})
          .then(() => {
            localStorage.clear(); // For Clearing Local Storage
            sessionStorage.clear(); // For Clearing Session Storage
            this.loggedInSuccess = false; //uncomment during deployment
            document.cookie.split(";").forEach(function (c) {
              // For Clearing the Cookies
              document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
          })
          .catch((error) => {
            console.error(error);
          });
    },
    async handleResponse(resp) {
      if (resp !== null) {
        try {
          const currentAccounts = this.msalLibrary.getAllAccounts();
          const accountId = currentAccounts[0]?.homeAccountId;
          const currentAcc = this.msalLibrary.getAccountByHomeId(accountId);

          const avScopeResponse = await this.getTokenRedirect(
              AV_REQUEST_SCOPES,
              currentAcc
          ).catch((error) => {
            console.log(error);
          });
          await this.$store.dispatch("setAVAccessTokenAction", avScopeResponse);
          sessionStorage.setItem("av_msal_token", JSON.stringify(avScopeResponse));
          AxiosFetchForMsal.defaults.headers.common["Authorization"] = `Bearer ${avScopeResponse.idToken}`;
          const token = JSON.parse(sessionStorage.getItem("av_msal_token"));
          this.username.user = token.account.name == null ? "" : token.account.name;
          this.username.useremail = token.account.username == null ? "" : token.account.username;
          this.username.userinitial =
              token.account.name == null
                  ? ""
                  : token.account.name.split(" ")[0].charAt(0) +
                  token.account.name.split(" ")[1].charAt(0);
          sessionStorage.setItem("userEmail", this.username.useremail);
          const segments = window.location.pathname.split('/').filter(Boolean);
          this.screenType = segments[segments.length - 2];
          if (this.accessUserList.some(email => email.toLowerCase() === this.username.useremail.toLowerCase())) {
            sessionStorage.setItem("ownerUpdate", "YES");
            this.ownerUpdate = 'YES';
          } else {
            sessionStorage.setItem("ownerUpdate", "NO");
            this.ownerUpdate = 'NO';
          }
          //await this.getAuthoriseUser();
          //await this.saveUserActivityOcean(token.idToken, token.account.username, segments[segments.length - 2]);

          //if(this.screenType === 'kaizen'){
          // await this.getAuthoriseUser();
          //await this.saveUserActivityLns(this.lnsAccessType);
          //}else{
          //await this.saveUserActivityOcean(token.idToken, token.account.username, segments[segments.length - 2]);
          //}

          this.$store.commit("setUserEmail", this.username.useremail);
          // await this.checkAuthorization(token.idToken, token.account.username);
          this.loggedInSuccess = true;
          sessionStorage.setItem("pageName", 'Onboard Your Product');
          sessionStorage.setItem("pageNameDescription", 'Onboard Your Product');
          sessionStorage.setItem("productCreatedBy", '');
          sessionStorage.setItem("fbpOwner", '');
        } catch (error) {
          if (error.response?.status === 400 && this.retryRequest) {
            this.retryRequest = false;
          } else if (error.response?.status === 401) {
            await getMsalIdToken();
          }
        }
      } else {
        const currentAccounts = this.msalLibrary.getAllAccounts();
        this.account = currentAccounts[0];
        if (!currentAccounts || currentAccounts.length < 1) {
          await this.signIn();
        } else {
          const accountId = currentAccounts[0].homeAccountId;
          const currentAcc = this.msalLibrary.getAccountByHomeId(accountId);
          if (currentAcc) {
            /*const response = await this.getTokenRedirect(LOGIN_REQUEST_SCOPES, currentAcc).catch((error) => {
              console.log(error);
            });*/
            const avScopeResponse = await this.getTokenRedirect(
                AV_REQUEST_SCOPES,
                currentAcc
            ).catch((error) => {
              console.log(error);
            });

            await this.$store.dispatch("setAVAccessTokenAction", avScopeResponse);
            sessionStorage.setItem("av_msal_token", JSON.stringify(avScopeResponse));
            AxiosFetchForMsal.defaults.headers.common["Authorization"] = `Bearer ${avScopeResponse.idToken}`;
            const token = JSON.parse(sessionStorage.getItem("av_msal_token"));
            this.username.user = token.account.name == null ? "" : token.account.name;
            this.username.useremail = token.account.username == null ? "" : token.account.username;
            this.username.userinitial =
                token.account.name == null
                    ? ""
                    : token.account.name.split(" ")[0].charAt(0) +
                    token.account.name.split(" ")[1].charAt(0);
            this.$store.commit("setUserEmail", this.username.useremail);
            const segments = window.location.pathname.split('/').filter(Boolean);
            this.screenType = segments[segments.length - 2];
            if (this.accessUserList.some(email => email.toLowerCase() === this.username.useremail.toLowerCase())) {
              sessionStorage.setItem("ownerUpdate", "YES");
              this.ownerUpdate = 'YES';
            } else {
              sessionStorage.setItem("ownerUpdate", "NO");
              this.ownerUpdate = 'NO';
            }

            //await this.getAuthoriseUser();
            //await this.saveUserActivityOcean(token.idToken, token.account.username, segments[segments.length - 2]);

            //if(this.screenType === 'kaizen'){
            // await this.getAuthoriseUser();
            //await this.saveUserActivityLns(this.lnsAccessType);
            //}else{
            //await this.saveUserActivityOcean(token.idToken, token.account.username, segments[segments.length - 2]);
            //}

            // await this.checkAuthorization(token.idToken, token.account.username);
            this.loggedInSuccess = true;
            sessionStorage.setItem("pageName", 'Onboard Your Product');
            sessionStorage.setItem("pageNameDescription", 'Onboard Your Product');
            sessionStorage.setItem("productCreatedBy", '');
            sessionStorage.setItem("fbpOwner", '');
          }
        }
      }
    },
    // async checkAuthorization(idToken, accountId) {
    //   const userInfo = {
    //     "userEmail": accountId.toLowerCase()
    //   }
    //   const options = await avLnsActions.authorizeUserDetails(
    //       userInfo,
    //       idToken
    //   );
    //   const response = await AxiosFetchForMsal(options);
    //   if (response.status === 200) {
    //     sessionStorage.setItem("accessType", response.data.accessType);
    //     await this.saveUserActivity(idToken, accountId.toLowerCase());
    //     this.unauthorized = false;
    //     this.loggedInSuccess = true;
    //   }else if (response.status === 401) {
    //     sessionStorage.setItem("accessType", response.data.accessType);
    //     this.loggedInSuccess = false;
    //     this.unauthorized = true;
    //   }else{
    //     sessionStorage.setItem("accessType", response.data.accessType);
    //     this.loggedInSuccess = false;
    //     this.unauthorized = false;
    //   }
    // },

    async getTokenRedirect(request, account) {
      request.account = account;
      return this.msalLibrary
          .acquireTokenSilent(request)
          .catch(async (error) => {
            console.log("silent token acquisition fails.");
            if (error instanceof msal.InteractionRequiredAuthError) {
              console.log("acquiring token using redirect");
              this.msalLibrary.acquireTokenRedirect(request);
            } else {
              console.error(error);
            }
          });
    }
  }
}
</script>
<style>
.even-row td:not(.text-highlight-green):not(.text-highlight-red) {
  background-color: #e2f3f9!important;
}
tr.even-row td.table-cell.cursor-pointer.text-hover:hover {
  background: #42b0d5 !important;
  color: #ffffff !important;
}
.td-width-110{
  min-width: 110px !important;
  max-width: 110px !important;
}
.right-215{
  right: 215px !important;
}
.right-210{
  right: 210px !important;
}
.slide-date-range.v-slider.v-input--horizontal .v-slider-thumb:nth-of-type(1) .v-slider-thumb__label {
  top: -50px !important;
  bottom: auto !important;
}
.slide-date-range.v-slider.v-input--horizontal .v-slider-thumb:nth-of-type(1) .v-slider-thumb__label > .v-slider-thumb__label-wedge {
  clip-path: polygon(0% 50%, 100% 50%, 50% 100%) !important;
  top: auto !important;
  bottom: -5.8px !important;
}
.slide-date-range.v-slider.v-input--horizontal .v-slider-thumb:nth-of-type(2) .v-slider-thumb__label {
  top: auto !important;
  bottom: -50px !important;
}
.slide-date-range.v-slider.v-input--horizontal .v-slider-thumb:nth-of-type(2) .v-slider-thumb__label > .v-slider-thumb__label-wedge {
  clip-path: polygon(50% 0%, 0% 50%, 100% 50%) !important;
  top: -5.8px !important;
  bottom: auto !important;
}
.left-300{
  left: 300px !important
}
.left-370{
  left: 370px !important
}
.left-420
{
  left: 420px !important
}
.left-470{
  left: 470px !important
}
.left-610{
  left: 610px !important
}
.left-680{
  left: 680px !important
}
.left-540{
  left: 540px !important
}
.left-520{
  left: 520px !important
}
.left-620{
  left: 620px !important
}
.left-720{
  left: 720px !important
}
.th-width-120,
.td-width-120{
  min-width: 120px !important;
  max-width: 120px !important;
}
.th-width-300,
.td-width-300{
  min-width: 300px !important;
  max-width: 300px !important;
}
.right-220{
  right: 220px !important;
}
.generic-bowler-class .mds-table { border-collapse: separate !important; border-spacing: 0; box-sizing: border-box; }
.generic-bowler-class .mds-table td { font-size: 10px !important; box-sizing: border-box; }
.generic-bowler-class .mds-table th{
  font-size: 10px !important;
}
.nested-table .mds-table td, .nested-table .mds-table th { border: 1px solid #333 !important; font-size: 13px !important; box-sizing: border-box; }
.nested-table { border-collapse: collapse !important; width: 100% !important; }
.nested-table td, .nested-table th { border: 1px solid #cccccc !important; }
.thumbs-bottom {
  position: relative;
}
.bowler-chart-table-design .mds-table table thead tr th {
  background: red !important;
  background-color: red !important;
}
.pa-2 {
  padding: 2px !important;
}

td.table-cell.cursor-pointer.text-hover:hover{
  background: #42b0d5 !important;
  color: #ffff;
}
.left-70 {
  left: 70px !important;
}
.right-0 {
  right: 0px;
}

.v-expansion-panel--active > .v-expansion-panel-title:not(.v-expansion-panel-title--static) {
  min-height: 44px !important;
}

.kpi-cell {
  font-weight: 700 !important;
}

.onScreenSizeChange {
  background: #f1f1f1 !important;
}

.v-table th .v-data-table-header__content span {
  font-weight: bolder !important;
}

.v-container {
  margin-left: auto;
  margin-right: auto;
  padding: 0 !important;
  width: 100%;
}

html {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback) !important;
}

.v-input--horizontal .v-input__prepend {
  margin-inline-end: 5px !important;
}

.v-slider.v-input--horizontal {
  margin-inline: 0 !important;
}

.v-input--horizontal .v-input__append {
  margin-inline-start: 5px !important;
}

.shrink-cells tr th,
.shrink-cells tr td {
  padding: 2px 2px !important;
  height: auto !important;
}

.shrink-secondary-cells tr th,
.shrink-secondary-cells tr td {
  padding: 8px !important;
  height: auto !important;
}

.shrink-cells .child-table-td {
  background: #d3e3fd !important;
}

.v-theme--light.v-table thead {
  background: #dbdbdb !important;
}

.custom-table thead .v-data-table__td,
.custom-table tbody .v-data-table__td {
  height: auto !important;
  padding: 10px !important;
}

.onScreenSizeChange {
  padding: 0 !important;
  background: #f1f1f1 !important;
}

.v-table th .v-data-table-header__content span {
  font-weight: bolder !important;
}

.v-container {
  margin-left: auto;
  margin-right: auto;
  padding: 0 !important;
  width: 100%;
}

html {
  font-family: var(--mds_brand_typography_text_font-family), var(--mds_brand_typography_text_font-family-fallback) !important;
}

.p-0 {
  padding: 0 !important;
}

.m-2 {
  margin: 2px !important;
}

.p-10 {
  padding: 10px !important;
}

.m-0 {
  margin: 0 !important;
}

.main-panel-div {
  background: #f7f7f7;
  padding: 10px;
  border: 1px solid rgb(219, 219, 219);
  border-radius: 10px;
}

.child-table-td {
  padding: 10px !important;
  background: rgb(241 241 241);
}

.table-all-border {
  border: 1px solid rgb(219, 219, 219);
  border-radius: 0px;
}

.m-10 {
  margin: 10px !important;
}

.copy-values-row {
  position: absolute;
  right: -15px;
  top: 10px;
  cursor: pointer;
  margin: 5px;
}


.position-relative {
  position: relative !important;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-24 {
  margin-top: 24px;
}

.mtb-10 {
  margin: 10px 0 !important;
}

.chart-bar-actual-forecast mc-icon::part(icon) {
  cursor: pointer;
  fill: #42b0d5
}

.chart-bars-vertical-align .mc-icon {
  display: contents !important;
}

.chart-bars-vertical-align {
  display: block !important;
  width: 100% !important;
  margin-left: 15px;
}

.chart-bar-actual-forecast {
  display: block !important;
}

.margin-right-10 {
  margin-right: 10px !important;
}

.margin-right-minus-10 {
  margin-right: -10px !important;
}

.d-block {
  display: block !important;
}

.margin-left-10 {
  margin-left: 10px !important;
}

.padding-0 {
  padding: 0 !important;
}

.margin-10 {
  margin: 10px !important;
}

.margin-rl-10 {
  margin: 0 10px;
}

.padding-top-0 {
  padding-top: 0 !important;
}

.border-bottom {
  border-bottom: thin solid rgba(0, 0, 0, .12) !important;
}

.border-left {
  border-left: thin solid rgba(0, 0, 0, .12) !important;
}

.cursor-pointer {
  cursor: pointer;
}

.p-5 {
  padding: 5px !important;
}


.type-suffix {
  padding: 0px !important;
}

mc-input::part(icon) {
  fill: #000000;
  position: absolute;
  right: 0;
  height: 31px;
  width: 20px;
  padding: 5px 1px;
  /*background: #ccc;*/
  top: 0;
}

.bg-table thead th {
  background-color: #e9f6fc !important;
}

.bg-table td,
.bg-table th {
  font-size: 13px !important;
  padding: 5px !important;
}

.mc-hint.small {
  font-size: 10px !important;
}

.mc-input-hint {
  font-size: 10px !important; /* Adjust the size as needed */
  color: gray; /* Optional: Change color for better visibility */
}

::v-deep(.mc-input-hint) {
  font-size: 10px !important; /* Adjust as needed */
}

.top-down-table .v-input__details {
  padding-inline: 0 !important;
  padding: 0 !important;
}

.pb-10 {
  padding-bottom: 10px !important;
}

.pocTable-header thead {
  background-color: #e9f6fc !important;
}

.pocTable-header thead th {
  background-color: #e9f6fc !important;
}

#poc-chart .apexcharts-text.apexcharts-xaxis-label {
  cursor: pointer !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.rcm-data-table .v-table__wrapper .v-data-table__th {
  background-color: #e9f6fc !important;
}

.v-timeline-item__opposite {
  padding: 10px 0px !important;
}

.v-timeline-divider__before {
  background: #42B0D5 !important;
}

.v-timeline-divider__after {
  background: #FFD029 !important;
}

.v-timeline-item__body {
  padding: 0 !important;
  min-width: 300px !important;
}

.v-timeline-item__body span,
.v-timeline-item__opposite {
  font-weight: 900 !important;
}

.v-timeline-divider__after {
  inset-inline-end: 0 !important;
}

.v-timeline-divider__before {
  inset-inline-start: 0 !important;
}

.v-timeline-divider {
  border-right: 3px solid #CFCFCF !important;
}

.v-timeline-item__body {
  position: relative !important;
}

.display-grid {
  display: grid;
}

.d-flex {
  display: flex;
}

#focusOfTheDayTable tbody tr td:nth-child(2) {
  text-align: justify;
}

.text-align-justify {
  text-align: justify;
}

.line-height-normal {
  line-height: normal;
}

.gemini-daily-tab tbody tr:hover {
  background-color: #42b0d54f;
  cursor: pointer
}

.filter-sec .hide-input-details .v-input__details {
  display: none !important;
}

.filter-sec .hide-input-details {
  margin-top: 10px;
}

.rotate-btn {
  vertical-align: top;
  transform: rotate(7deg);
  -ms-transform: rotate(90deg); /* IE 9 */
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari and Chrome */
  -o-transform: rotate(90deg); /* Opera */
}

.h4-link-text {
  text-decoration: underline;
  color: #42b0d5;
  cursor: pointer;
}

.active-panel-bg-color {
  background: #f1f1f1;
}

.cursor-pointer {
  cursor: pointer;
}

.previous-comments {
  background: #42b0d545;
  border-radius: 8px;
  padding: 10px;
  margin: 5px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.previous-comments .mc-icon {
  font-size: 20px;
  color: #5c6bc0;
  margin-right: 8px;
}

.previous-comments h4 {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  color: #333;
}

.previous-comments small {
  font-size: 13px;
  color: #666;
}

.previous-comments strong {
  font-weight: 600;
  color: #444;
}

.previous-comments .comment-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.previous-comments .comment-meta div {
  display: flex;
  align-items: center;
}

.previous-comments .comment-meta mc-tooltip {
  cursor: pointer;
}

.previous-comments .float-left {
  margin-right: 5px;
}

.line-height-normal {
  line-height: 1.5;
}

.selected-bg {
  background-color: lightblue; /* Change to your preferred color */
}

.selected-bg-color {
  color: #000000 !important;
}

.selected-row {
  background-color: #d3e3fd !important; /* Light blue */
}

.action-buttons {
  display: flex;
  justify-content: center; /* Centers horizontally */
  align-items: center; /* Centers vertically */
  gap: 0px; /* Adds spacing between buttons */
}

.assignment-badge {
  border: 1px solid;
  border-radius: 50px;
  padding: 0px 8px;
  font-size: 9px;
  background: #42b0d5;
  color: #ffffff;
  font-weight: 200;
}

.tab-cover-div {
  border: 1px solid #cccccc;
  padding: 15px;
  border-radius: 0 10px 10px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.align-targets-inline {
  float: left;
  margin-right: 5px;
  display: flex;
  width: 135px;
}

.highlight-current-week {
  background-color: #f1f1f1; /* Light yellow */
  font-weight: bold;
  border: 2px solid #f1f1f1;
  display: flow-root;
}

.font-size-11 {
  font-size: 11px;
}

.font-size-9 {
  font-size: 9px;
}

.weekly-data-table tr td {
  padding: 0 !important;
}

.highlight-current-week::before {
  content: "";
  display: block;
  background-color: yellow; /* Change to your desired color */
}

/* Alternatively, use the adjacent sibling selector */
.weekly-data-table tr td + .highlight-current-week {
  background-color: yellow; /* Changes the previous div's background */
}

.total-row {
  font-weight: bold;
  background-color: #f0f0f0;
}

.total-row-addition tbody tr:nth-child(1) {
  background-color: #f5f5f5;
  font-weight: bold;
}

.time-period-div .v-input__details {
  display: none;
}

.a-link {
  text-decoration: underline;
  color: #42B0D5;
  cursor: pointer;
}

.bg-red-100 {
  color: red !important;
}

.display-inline-block {
  display: inline-block;
}

.w-100 {
  width: 100%;
}

.graph-card-title {
  width: 100%;
  padding: 0 !important;
  background: #f7f7f7;
  border-bottom: 1px solid #dbdbdb;
  border-radius: 5px 5px 0 0;
}


.d-none-message .v-input__details {
  display: none !important;
}

/*---------Table-------*/

.text-green {
  background-color: #d0f0d0;
}

.text-highlight-green {
  background-color: #7FD175 !important;
  color: #141414 !important;
}

.bg-th-current-yearWeek {
  background: #FFD029 !important;
  color: #141414 !important;
}

.text-only-green {
  color: green;
}

.text-highlight-red {
  color: #FFFFFF !important;
  font-weight: bold !important;
  background-color: #B80012 !important;
}

.text-orange {
  background-color: #fff3cd;
}

.table-cell {
  border: 1px solid #000000;
  padding: 2px !important;
  text-align: center;
}

.table-head {
  border: 1px solid #000000;
  padding: 5px !important;
  text-align: center;
  font-weight: 600 !important;
}

.table-cell-no-padding {
  border: 1px solid #000000;
  padding: 0 !important;
}

.inner-cell {
  border-top: 1px solid #000000;
  font-size: 12px;
  text-align: center;
  padding: 0px !important;
}

.bg-th-light-blue {
  background: #42B0D5 !important;
  color: #ffffff !important;
}

.bg-th-dark-blue {
  background: #42B0D5 !important;
  color: #ffffff !important;
}

.bg-th-grey {
  background: #d0d0d0 !important;
}

.inner-cell.first-child {
  border-top: none;
}

.border-right {
  border-right: 1px solid #000000;
}

.border-left {
  border-left: 1px solid #000000;
}

.vertical-text {
  writing-mode: vertical-rl; /* or vertical-lr */
  transform: rotate(180deg); /* optional: flips text upright */
  text-align: center;
  vertical-align: middle;
  padding: 8px;
  font-weight: 600;
}

.border-collapse {
  border-collapse: collapse;
}

.text-decoration-underline {
  text-decoration: underline;
}

td.table-cell.cursor-pointer.text-hover:hover {
  background: #e2f3f9;
  color: #ffff !important;
}

td.table-cell.cursor-pointer.text-hover:hover .tooltip-hover,
td.table-cell.cursor-pointer.text-hover:hover .tooltip-hover strong {
  color: #ffff !important;
}

.metric-details-span span:hover {
  text-decoration: underline;
}

.service-table.active,
.terminal-table.active {
  background: #42b0d5 !important;
  color: #ffff !important;
}

.highlight-row {
  background: #E2F3F9 !important;
  color: #00243D !important;
}

.highlight-nodata-row {
  background: lightgrey;
  opacity: 0.6;
}

.action-link-inline {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}


.odd-row {
  background-color: #f9f9f9; /* Light grey background */
}

.vue-apexcharts {
  min-height: 0 !important;
}

mc-card::part(content-container) {
  margin: 0;
  padding: 0px;
}

.remove-bg {
  background-color: transparent !important;
}

.owner-text-wrap {
  min-width: 150px !important;
  white-space: normal !important;
  word-break: break-word !important;
}

.kpi-text-wrap {
  min-width: 100px !important;
  white-space: normal !important;
  word-break: break-word !important;
}

.highlight-selected {
  background-color: #42b0d5 !important;
  color: #FFFFFF !important;
}

.card-carousel {
  display: flex;
  overflow-x: auto;
  gap: 16px;
  scroll-snap-type: x mandatory;
}

.carousel-card {
  flex: 0 0 calc(50% - 10px); /* Show two cards at a time */
  scroll-snap-align: start;
  min-width: 50%; /* Ensure each card is half the container width */
}

.apexcharts-point-annotations rect {
  display: none !important;
}

.active-card {
  background-color: #42B0D5;
}

.shining-image {
  width: 300px; /* Adjust as needed */
  animation: shine 2s infinite;
}

/*
.glowing-image {
  animation: intenseGlow 1.5s infinite alternate;
}

@keyframes intenseGlow {
  from {
    filter: drop-shadow(0 0 10px rgba(0, 123, 255, 0.7));
  }
  to {
    filter: drop-shadow(0 0 30px rgba(0, 123, 255, 1));
  }
}

 */

@keyframes shine {
  0% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.5);
  }
  100% {
    filter: brightness(1);
  }
}

.ai-icon {
  font-size: 15px;
  padding-top: 5px;
  font-weight: bold;
  color: white;
  text-align: center;
  width: 15px;
  height: 15px;
  line-height: 15px;
  border-radius: 4px;
  background: transparent;
  animation: glow 1.5s infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 2px #00f, 0 0 4px #00f, 0 0 6px #00f;
    color: #42B0D5;
  }
  to {
    text-shadow: 0 0 6px #00f, 0 0 10px #00f, 0 0 14px #00f;
    color: #fff;
  }
}

.min-width-100 {
  min-width: 100px;
}

.pt-5 {
  padding-top: 20px !important;
}

.legend-color-info {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: auto;
}

.legend-color-PY {
  background-color: #9ED7EA;
}

.legend-color-actual {
  background-color: #005986;
}

.legend-color-plan {
  background-color: #81000D;
}

.ai-selected-panel {
  border: 1px solid #cccc;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.loading-text {
  font-weight: 600;
  color: #0077B2;
  animation: pulse 1.5s infinite;
}

.min-width-200 {
  min-width: 200px !important;
  width: 200px !important;
  max-width: 200px !important;
}

.min-width-100 {
  min-width: 100px !important;
  width: 100px !important;
  max-width: 100px !important;
}

.min-width-150 {
  min-width: 150px !important;
  width: 150px !important;
  max-width: 150px !important;
}

.pl-5 {
  padding-left: 5px !important;
}

.pl-3 {
  padding-left: 3px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

.mds-table__column--sticky {
  box-shadow: none !important;
  outline: 1px solid #ccc;
}
.left-0 {
  left: 0 !important;
}
.left-70 {
  left: 70px !important;
}

.right-0 {
  right: 0 !important;
}

.left-200 {
  left: 200px !important;
}

.left-350 {
  left: 350px !important;
}
.min-width-85{
  min-width: 85px !important;
}
.left-300{
  left: 300px !important
}
.left-375{
  left: 375px !important
}
.right-150{
  right: 150px !important
}
.right-50{
  right: 50px !important
}
.right-100{
  right: 100px !important
}
.right-200{
  right: 200px !important
}
.left-150{
  left: 150px !important
}
.min-width-75{
  min-width: 75px !important;
  width: 75px !important;
  max-width: 75px !important;
}
.current-head {
  text-align: center;
  color: black;
  background-color: #ffd029 !important;
}
.bg-th-grey {
  background: #f0f0f0 !important;
}
.left-525{
  left: 525px !important;
}
.left-400 {
  left: 400px !important;
}
.left-660{
  left: 660px !important;
}
.left-590{
  left: 590px !important;
}
.left-450 {
  left: 450px !important;
}

.left-500 {
  left: 500px !important;
}

.left-550 {
  left: 550px !important;
}

.left-600 {
  left: 600px !important;
}

.left-650 {
  left: 650px !important;
}

.value-container {
  display: flex;
  align-items: center; /* vertically centers both */
  justify-content: center; /* centers within the cell */
  gap: 4px; /* small space between 85% and image */
}

.ai-icon {
  position: relative;
  display: inline-block;
  color: white;
  font-weight: bold;
  font-size: 14px;
}

/* two little stars ✨ */
.ai-icon::before,
.ai-icon::after {
  content: "✦";
  position: absolute;
  color: #ffd700;
  font-size: 8px;
  transform: rotate(15deg);
}

/* first star */
.ai-icon::before {
  top: -4px;
  right: -4px;
}

/* second smaller star */
.ai-icon::after {
  top: -2px;
  right: 4px;
  font-size: 6px;
  opacity: 0.8;
}


@keyframes pulse {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.8;
  }
}

.slide-date-range .v-input__details {
  display: none;
}

.chart-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  white-space: nowrap;
  padding-top: 60px;
}

.chart-wrapper {
  display: inline-block;
}

.my-tooltip {
  transform: translateY(15px); /* move it below */
}

.equal-col-4 {
  width: 23%;
  float: left;
  margin: 0 10px;
}

.equal-col-5 {
  width: 16%;
  float: left;
  margin: 0 3px;
}

.min-max-height-350 {
  min-height: 350px;
  max-height: 350px;
}

#P0-metric-page-id .table-cell-no-padding{
  min-width: 70px !important;
}

#P0-metric-page-id  mc-switch::part(label-container) {
  align-items: center;
  flex-direction: column;
}
#P0-metric-page-id  mc-switch::part(label) {
  color: #B80012;
}
#P0-metric-page-id  mc-switch[checked]::part(checkmark) {
  background-color: #B80012;
}

.mds .mds-table thead tr:first-child th:last-child,
.mds .mds-table thead tr:first-child td:last-child,
.mds .mds-table tbody:last-child tr:last-child td:last-child,
.mds .mds-table tbody:last-child tr:last-child th:last-child,
.mds .mds-table tfoot tr:last-child td:last-child,
.mds .mds-table tfoot tr:last-child th:last-child {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.table-cell-no-padding {
  min-width: 100px;
}

.table-head,
.table-cell,
.inner-cell,
.table-cell-no-padding,
.font-size-10 {
  font-size: 10px;
}

html, body, #app {
  height: 100%;
  margin: 0;
}

.v-application {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-layout {
  flex: 1;
  padding-left: 60px;
  padding-top: 70px;
  min-height: 90vh;
}

.content-wrapper {
  padding-bottom: 16px;
}

.footer-message {
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 900;
  display: inline-block;
  width: 100%;
}

.mc-file-upload_default::part(button) {
  color: #40AB35;
}
.mc-file-upload_drag-drop::part(drag-drop-area) {
  opacity: 0.5;
  pointer-events:none;
}

.th-width-50,
.td-width-50{
  min-width: 50px !important;
  max-width: 50px !important;
}

.th-width-70,
.td-width-70{
  min-width: 70px !important;
  max-width: 70px !important;
}
.th-width-75,
.td-width-75{
  min-width: 75px !important;
  max-width: 75px !important;
}

.th-width-100,
.td-width-100{
  min-width: 100px !important;
  max-width: 100px !important;
}
.th-width-200,
.td-width-200{
  min-width: 200px !important;
  max-width: 200px !important;
}
.th-width-250,
.td-width-250{
  min-width: 250px !important;
  max-width: 250px !important;
}
.th-width-150,
.td-width-150{
  min-width: 150px !important;
  max-width: 150px !important;
}

.z-index-1{
  z-index: 1;
}

.display-contents{
  display: contents !important;
}

/* Normal UI */
#wireframe-dashboard-page  .mds-table--scrollable {
  max-height: calc(100vh - 200px);
  overflow: auto;
}

/* PDF Mode */
#wireframe-dashboard-page  .pdf-mode {
  overflow: visible !important;
  max-height: none !important;
}

/* Disable sticky columns in PDF */
#wireframe-dashboard-page .pdf-mode .mds-table__column--sticky {
  position: static !important;
}
.align-items-end{
  align-items: end;
}

#generic-bowler-chart-template .table-cell-no-padding{
  min-width: 60px !important;
}

.pa-06-12{
  padding: 6px 12px !important;
}

.text-center {
  text-align: center !important;
}

.align-items-flex-end{
  align-items: flex-end !important;
}

.align-items-flex-center{
  align-items: center !important;
}

.text-red{
  color: red !important;
}

.active-accordion {
  background: #E2F3FB;
}

.active-menu {
  background: #A1D1E8;
  color: #FFFFFF;
}

.active-menu mc-button::part(icon) {
  fill: #FFFFFF;
}
.active-menu mc-button::part(button),
.active-menu mc-button.mc-list-item.small::part(button){
  color: #FFFFFF !important;
}

mc-accordion-item::part(heading) {
  padding-left: 10px !important;
}

.product-created-details-div{
  float: left;
  display: inline-block;
  text-align: start;
  font-size: 14px;
  line-height: normal;
}

.mt-5{
  margin-top: 5px;
}

.mt-6{
  margin-top: 6px;
}

.mt-7{
  margin-top: 7px;
}

.back-to-collection-top-bar{
  float:right;
}

.mds-table table tr td, .mds-table table tr th, .mds-table.mds-table--outer-border-corners-square{
  border-radius: 0px !important;
  font-size: 12px !important;
}
</style>
